import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { PartnerProvisionApi } from "../../../../../../services/Api/Partner/partnerTypes";

export const getProvisionAmount = (provision: PartnerProvisionApi) => {
	if (provision.type === "PERCENT") return `${provision.provision} %`;
	return FormatMoney({ amount: provision.provision, currency: "PLN" });
};
